import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAtom } from 'jotai';
import { currentUserAtom, authLoadedAtom } from '../auth/AuthAtoms';

const PrivateRoute = () => {
    const [currentUser] = useAtom(currentUserAtom);
    const [authLoaded] = useAtom(authLoadedAtom);

    if (!authLoaded) return null;
    return currentUser ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
